module.exports = __webpack_public_path__ + "media/components/members_components/static/delete-4f7b96428afffbef0feef99a7d8d6780.png";